import $ from '../core/Dom';
import Viewport from '../core/Viewport';

// Note: The css-vars-ponyfill does *not* work w/ webpack-dev-server, and I'm not going to spend any time on fixing that right now :) – mmikkel
import cssVars from 'css-vars-ponyfill';

require('intersection-observer');

let prevScrollTop = Viewport.scrollTop;
let direction = 'down';

let observer;

const updateBackgroundColor = () => {
    const $intersecting = $('.js-intersecting[data-bg-trigger]');
    
    if ($intersecting.length > 0) {
        let newColorStr = '#fff;#000';
        
        if (direction === 'down') {
            newColorStr = $($intersecting.get($intersecting.length - 1)).data('bg-trigger');
        } else {
            newColorStr = $($intersecting.get(0)).data('bg-trigger');
        }

        const variables = {};
        const colors = newColorStr.split(';');
        
        if (colors[0]) {
            variables['--current-background-color'] = colors[0];
        }
        if (colors[1]) {
            variables['--current-foreground-color'] = colors[1];
        }

        cssVars({
            variables
        });
    }
};

export default () => {
    if ($('html').hasClass('is-live-preview')) {
        return;
    }

    if (!observer) {
        observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const { target, isIntersecting } = entry;
                
                if (isIntersecting) {
                    target.classList.add('js-intersecting');
                } else {
                    target.classList.remove('js-intersecting');
                }
                
                updateBackgroundColor();
            });
        }, {
            threshold: 0,
            rootMargin: '-50%'
        });

        Viewport.on('scroll', () => {
            const scrollTop = Viewport.scrollTop;
            direction = scrollTop > prevScrollTop ? 'down' : 'up';
            prevScrollTop = scrollTop;
        });
    }

    // Create waypoints
    const $waypoints = $('[data-bg-trigger]');
    
    $waypoints.each(el => {
        el.className += ' js-intersect';
        observer.observe(el);
    });
};
